import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isResourceGroupEditionRequestFailure(group) {
      const state = getState().find(
        ({ group: { uuid } }) => uuid === group.uuid,
      );

      return state ? state.requestState.isFailure : false;
    },
    isResourceGroupEditionRequestPending(group) {
      const state = getState().find(
        ({ group: { uuid } }) => uuid === group.uuid,
      );

      return state ? state.requestState.isPending : false;
    },
    isResourceGroupEditionRequestSuccess(group) {
      const state = getState().find(
        ({ group: { uuid } }) => uuid === group.uuid,
      );

      return state ? state.requestState.isSuccessful : false;
    },
  };
}

export { createSelector };
